var _excluded = ["children", "fieldSize", "htmlFor"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import styled from 'styled-components';
var FieldMessageContainer = styled.label.withConfig({
  componentId: "CL__sc-o6k9nl-0"
})(["display:block;color:var(--text-color-dim);", " ", " ", ""], _ref => {
  var {
    fieldSize
  } = _ref;
  return fieldSize === 'large' ? "\n    font: var(--body-text-small);\n    padding: calc(var(--spacing-1) * 1.5) var(--border-radius-x-small) 0;\n    " : "";
}, _ref2 => {
  var {
    fieldSize
  } = _ref2;
  return fieldSize === 'medium' ? "\n    font: var(--body-text-x-small);\n    padding: calc(var(--spacing-1) * 1.5) var(--border-radius-x-small) 0;\n    " : "";
}, _ref3 => {
  var {
    fieldSize
  } = _ref3;
  return fieldSize === 'small' ? "\n    font: var(--body-text-x-small);\n    padding: var(--spacing-1) var(--border-radius-x-small) 0;\n    " : "";
});
var FieldMessage = /*#__PURE__*/React.forwardRef((_ref4, ref) => {
  var {
      children,
      fieldSize = 'medium',
      htmlFor
    } = _ref4,
    props = _objectWithoutProperties(_ref4, _excluded);
  return /*#__PURE__*/React.createElement(FieldMessageContainer, _extends({
    fieldSize: fieldSize,
    htmlFor: htmlFor,
    ref: ref
  }, props), children);
});
export default FieldMessage;